import { setupQueryCache } from '@data/api/queryClient';
import { asyncSuspense } from '@data/other/asyncSuspense';
import bind from 'bind-decorator';
import Components from './Components';
import Environment from './Environment';
import Property from './Property';

export class Store {
  property = new Property();
  components = new Components();
  environment = new Environment();

  @bind async init() {
    await setupQueryCache();
    await this.environment.init();
    this.property.init();
    return this;
  }
}

const store = new Store();

export const initializeStore = asyncSuspense(store.init, 'store');

export interface StoreProps {
  store: Store;
}

export default store;
